import { Fragment } from 'react';

const Version = new Map([
  [0, Fragment]
]);

export const get = (version = Version, v = 1) => {
  if (version.has(v)) return version.get(v);
  return version.get(1);
};
